module.exports = __webpack_public_path__ + "img/bottomList3_active.aaf72a4d.svg";